var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalStacked01A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.8 72.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #016696;\r\n      }\r\n\r\n      .cls-2 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-3 {\r\n        letter-spacing: -.11em;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        fill: #f8a918;\r\n      }\r\n\r\n      .cls-6 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-7 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-8 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-9 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-family: Beckan-Regular, Beckan;\r\n        font-size: 59.3px;\r\n      }\r\n\r\n      .cls-10 {\r\n        letter-spacing: -.09em;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Our_Style",
    "data-name": "Our Style"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.01,6.59h0s2.54,3.85,2.54,3.85l.02.04,20.27,50.1,1.48,3.28c.5,1.11-.25,2.37-1.53,2.55-.77.11-1.5.21-1.8.24-1.3.12-2.61.17-3.91.17-.66,0-1.33-.02-1.99-.05-1.86-.09-3.74-.29-5.58-.62-.76-.13-3.33-.76-3.33-.76,0,0,.98-1.6,1.19-2.26l.85-2.73c-3.29-.86-6.38-2.18-9.19-3.92l-1.96,2.39c-.45.55-1.7,2.19-1.7,2.19,0,0-1.73-1.3-2.33-1.73-1.48-1.05-2.87-2.2-4.15-3.43-1.29-1.24-2.49-2.59-3.56-3.99-.43-.56-1.46-2.37-1.46-2.37,0,0,1.71-.76,2.38-1.09l3.15-1.58c-1.56-2.59-2.63-5.38-3.18-8.29,0-.03,0-.05-.01-.08l-3.78.55c-.76.11-2.7.45-2.7.45,0,0-.44-1.91-.52-2.58C0,35.18-.05,33.44.05,31.74c.1-1.63.34-3.26.71-4.86.15-.66.76-2.38.76-2.38,0,0,1.95.33,2.7.51l4.01.94c.99-2.76,2.46-5.35,4.39-7.72l-3.51-2.19c-.63-.39-2.31-1.35-2.31-1.35,0,0,1.29-1.65,1.77-2.17,1.2-1.29,2.52-2.51,3.92-3.62,1.16-.92,2.39-1.78,3.67-2.57.57-.35,1.27-.46,1.94-.33l2.92.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.17.04c-3.98.14-9.6.99-13.8,2.94-1.42.66-2.07,1.44-2.04,1.69.21,1.42,3.38,4.71,3.38,4.71,8.75-3.88,23.7-2.48,24.01,5.92.42,11.33-17.02,10.18-7.75,34.8.69,1.84,4.49,10.67,5.81,14.18.15.39.9.37.84-.04-1.4-9.79-5.46-21.38,1.25-28.13,2.25-2.26,5.52-4.12,9.03-6.03,8.15-4.44,9.1-14.69,6.17-19.69C61.03,3.44,50.88-.42,38.17.04Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Dimensions"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(78.6 56.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.62,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 63.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 80.29,
    y: 0
  }, "adigm "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 250.55,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 284.11,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 300.48,
    y: 0
  }, "udi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 377.51,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 408.47,
    y: 0
  }, "s")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalStacked01A);
export default __webpack_public_path__ + "static/media/verticalStacked_01a.d9f9ffaf6967faff771286d926ba2e9f.svg";
export { ForwardRef as ReactComponent };